import { Component, OnInit, ViewChildren } from '@angular/core';

import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { AuthenticationService } from '../../services/authentication.service';
import { Router } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { ChooseUnitModalComponent } from '../choose-unit-modal/choose-unit-modal.component';
import { UserService } from 'src/app/shared/services/user.service';
import { PageAccessControlService } from 'src/app/shared/services/page-access-control.service';
import { PermissionService } from 'src/app/shared/services/permission.service';
import { IUnidade } from 'src/app/shared/interfaces/unidade/iunidade';
import { tap } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  error = false;
  // essa variavel mensagem, faz o biding com as mensagens de erro de login
  public message: string = ''
  // essa variavel controla a exibição da animacao de carregamento
  public spinner: string = 'noShow';

  public loading: boolean = false;
  // form group do formulario de login
  public formAuth: FormGroup = this.formBuilder.group({
    email: ['', [Validators.email] ],
    password: [''],
    remember: ''
  })

  allowedUnits!: IUnidade[];


  slides = [
    { img: 'assets/slide.png', active: true },
    { img: 'assets/slide2.png', active: false },
    { img: 'assets/slide3.png', active: false }
  ];

  latX = 0;

  ignoreInterval = false;

  @ViewChildren('img') imgs!: any;


  protected issueProfessional: boolean = false;
  // injeção de dependencia
  constructor (
    private formBuilder: FormBuilder,
    private authService: AuthenticationService,
    private router: Router,
    private dialogService: DialogService,
    private userService: UserService,
    private pageAccessControlService: PageAccessControlService,
    private permissionService: PermissionService
    ){}

  // toda vez que o usuario entra na tela de login ele é redirecionado para home, afim de verificar se ja esta
  // autenticado, o guarda da rota 'home' faz essa autenticação
  ngOnInit(): void {

    setInterval(() => {
      if(!this.ignoreInterval){
        this.nextSlide(false);
      } else {
        this.ignoreInterval = false;
      }
    }, 5000)
    //this.router.navigate(['home'])
    //this.authService.logOut();
    this.formAuth.statusChanges.subscribe(() => {
      this.error = false;
    })
  }

  prevSlide(ignoreInterval = true) {
    if(ignoreInterval){
      this.ignoreInterval = true;
    }
    let index = this.slides.findIndex((x: any) => x.active == true);
    this.slides[index].active = false;
    let width = this.imgs.get(index).nativeElement.offsetWidth;
    if(index > 0){
      this.slides[index - 1].active = true;
      this.latX = ((index - 1) * -1) * (width + 52); //52
    }else{
      this.slides[this.slides.length - 1].active = true;
      this.latX = ((this.slides.length - 1) * -1) * (width + 52);
    }
  }

  nextSlide(ignoreInterval = true) {
    if(ignoreInterval){
      this.ignoreInterval = true;
    }
    let index = this.slides.findIndex((x: any) => x.active == true);
    this.slides[index].active = false;
    let width = this.imgs.get(index).nativeElement.offsetWidth;
    if(index < (this.slides.length - 1)){
      this.slides[index + 1].active = true;
      this.latX = ((index + 1) * -1) * (width + 55);
    }else{
      this.slides[0].active = true;
      this.latX = 0;
    }
  }


  navigateForgotPassword(){
    this.router.navigate(['/recuperar-senha']);
  }

  public onSubmit() {
     this.error = false;
     this.loading = true;

     if (this.formAuth.valid){
        this.authService.authPOST({
        email: this.formAuth.value.email,
        password: this.formAuth.value.password}).subscribe({
          next: (response: any) => {

            if(Array.isArray(response)) {
              this.openUnitModal(this.formAuth.value, response);
            } else {
              localStorage.setItem('access_token', response.accessToken);
              localStorage.setItem('refresh_token', response.refreshToken);
              localStorage.setItem('realm', response.realm);
              localStorage.setItem('clientId', response.clientId);
              localStorage.setItem('userId', response.userId);
              localStorage.setItem('unitId', response.unitId);
              this.getUser(response.userId)
            }

          },

          error: (erro: any) => {
            this.loading = false;
            this.error = true;
          }

        })
        // validações para exibir ou não os erros de login
     }  else {
        this.error = true;
     }

  }

  isValid(formControlName: string) : Boolean {
    return (<Boolean>this.formAuth.get(formControlName)?.valid) && !(<Boolean>this.formAuth.get(formControlName)?.pristine);
  }

   openUnitModal(credentials: {email: string, password: string} , units : any []) {
     const ref = this.dialogService.open(ChooseUnitModalComponent, {
       header: `Selecione uma unidade`,
       width: '70%',
       style: {
         'height': 'auto',
         'max-height': '98vh'
       },
       baseZIndex: 10000,
       dismissableMask: false,
       styleClass: 'dialogComponent',
       closable: false,
       data: {
         credentials,
         units
       }
     });

     ref.onClose.subscribe((response: any) => {
       if (response) {
         this.getUser(response.userId);
       }
     });
   }

  getUser(userId: number){
    this.userService.getbyID(userId).pipe(
      tap((user: any) => {
        this.issueProfessional = user["@type"] == "Professional";
      })
    ).subscribe({
      next: (res: any) => { this.getAllowedPages(res.userGroup.id)},
      error: (err: any) => { console.log( 'ocorreu um erro: ', err)}
    })
  }

  getAllowedPages(userGroupId: number){
    this.pageAccessControlService.getById(userGroupId).subscribe({
      next: (res: any) => { this.setPermissionList(res['hydra:member'])},
      error: (err: any) => { console.log( 'ocorreu um erro: ', err) }
    })
  }

  setPermissionList(pages: any){

    let permissionList: { page: string, path: string }[] =[]
    let rawPermissions: string[] = []
    pages.forEach((p: any) => {
      rawPermissions.push(p.page)
      switch (p.page) {
        case 'Receitas':
          permissionList.push({
            page: 'receita',
            path: 'financeiro/receita'
          })
          break;
        case 'Despesa Caixa':
        case 'Despesas Caixa':
        case 'Despesa  Caixa':
        case 'Despesas Caixas':
          permissionList.push({
            page: 'despesaCaixa',
            path: 'financeiro/despesaCaixa'
          })
          break;
        case 'Caixa':
          permissionList.push({
            page: 'caixa',
            path: 'financeiro/Caixa'
        })
          break;
        case 'Despesas Bancárias':
          permissionList.push({
           page: 'despesaBancarias',
           path: 'financeiro/despesaBancarias'
          })
          break;
        case 'Nota Fiscal':
          if(!p.isReport) {
            permissionList.push({
              page: 'notaFiscal',
              path: 'financeiro/notaFiscal'
            })
          }
          break;
        case 'Calendário de Pagamentos':
        case 'Calendário de Pagamento':
          permissionList.push({
            page: 'calendarioPagamentos',
            path: 'financeiro/calendarioPagamentos'
          })
          break;
        case 'Unidades':
          permissionList.push({
            page: 'unidades',
            path: 'cadastro/unidades'
          })
          break;
        case 'Profissionais':
          permissionList.push({
            page: 'profissionais',
            path: 'cadastro/profissionais'
          })
          break;
        case 'Funcionários':
          permissionList.push({
            page: 'funcionarios',
            path: 'cadastro/funcionarios'
          })
          break;
        case 'Formas de Pagamento':
          permissionList.push({
            page: 'formaPagamento',
            path: 'cadastro/forma-pagamento/home'
          })
          break;
        case 'Dados Cadastro':
          permissionList.push({
            page: 'dadosCadastro',
            path: 'cadastro/dados'
          })
          break;
        case 'Exames':
          permissionList.push({
            page: 'exames',
            path: 'cadastro/exames'
          })
          break;
        case 'Serviços':
          permissionList.push({
            page: 'servicos',
            path: 'cadastro/servico'
          })
          break;
        case 'Entrega Exames':
          permissionList.push({
            page: 'entregaExame',
            path: 'cadastro/entrega-exame'
          })
          break;
      }

      if (p.isReport) {
        switch (p.page) {
          case 'Nota Fiscal':
            permissionList.push({
              page: 'notasFiscaisReport',
              path: 'relatorios/notasFiscais'
            })
            break;
          case 'Repasses Profissionais':
            permissionList.push({
              page: 'repassesProfissionaisReport',
              path: 'relatorios/repassesProfissionais'
            })
            break;
          case 'Financeiro':
            permissionList.push({
              page: 'financeiroReport',
              path: 'relatorios/financeiro'
          })
          break;
          case 'Resultado':
            permissionList.push({
              page: 'resultado-profissional',
              path: 'resultado-profissional'
          });
          break;
          case 'Bancario':
            permissionList.push({
              page: 'bankReport',
              path: 'relatorios/bancario'
          })
        }
      }

    })

    this.permissionService.setPermissions(permissionList, rawPermissions)

    this.router.navigate([permissionList[0].path], {queryParams: {isLogged: true}});
    this.allowedUnits && !this.issueProfessional ? this.openUnitModal(this.formAuth.value, this.allowedUnits): null
    this.loading = false;
  }
}
